// Nocturne : Inter (repli system-ui) et mono système, aucune police à héberger. Les polices du thème
// « Solo Leveling » (latin seulement) sont mises en cache par le service worker, pour marcher hors connexion.
import '@fontsource/cinzel/latin-500.css';
import '@fontsource/cinzel/latin-700.css';
import '@fontsource/chakra-petch/latin-400.css';
import '@fontsource/chakra-petch/latin-500.css';
import '@fontsource/chakra-petch/latin-600.css';
import '@fontsource/chakra-petch/latin-700.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import '@fontsource/jetbrains-mono/latin-700.css';
import './nocturne.css';
import './tokens.css';
import './systeme.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import { App } from './App';
import { ecouterInstallation } from './lib/installation';
import { appliquerApparence, lireTheme } from './lib/theme';

appliquerApparence(lireTheme());
// L'invitation à installer de Chrome et Edge n'arrive qu'une fois, tôt : l'installation guidée la garde (lot 6.1).
ecouterInstallation();
// Une nouvelle version attend : trouvée dans les premières secondes après l'ouverture, elle s'applique tout de suite
// (on n'a encore rien commencé) ; trouvée plus tard, dès que l'app passe en arrière-plan, jamais sous les yeux (pas de
// rechargement en pleine séance). Sur iPhone, la PWA n'est presque jamais fermée : sans cela, l'ancienne version
// resterait en place, et un serveur plus récent pourrait la refuser (la notice du lot 5.2, le 03/11).
const DEMARRAGE_MS = 10_000;
let enAttente = false;
const mettreAJour = registerSW({
  immediate: true,
  onNeedRefresh() {
    enAttente = true;
    if (performance.now() < DEMARRAGE_MS) {
      void mettreAJour(true);
      return;
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') void mettreAJour(true);
    });
  },
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    // Chercher une nouvelle version à chaque retour au premier plan, et toutes les 30 minutes.
    const chercher = () => void registration.update().catch(() => undefined);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') chercher();
    });
    window.setInterval(chercher, 30 * 60_000);
  },
});

// Le serveur, plus récent, refuse cette version (api.ts) : inutile d'attendre l'arrière-plan, elle ne marcherait pas.
window.addEventListener('alfred:version-perimee', () => {
  if (enAttente) void mettreAJour(true);
  else window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
